import type { UpdateWages } from '@web/onboarding/Checklist/onboardingChecklist.types';
import type { RestangularPosition } from '@web/onboarding/Checklist/DefineWagesModal/defineWagesModal.types';
import useSubmitWages from '@web/onboarding/Checklist/DefineWagesModal/hooks/useSubmitWages';
import useDefineWagesForPositionsForm from '@web/onboarding/Checklist/DefineWagesModal/hooks/useDefineWagesForPositionsForm';
import { mapPositionsFromRestangularToPositionOnboardingModel } from '@web/onboarding/Checklist/DefineWagesModal/defineWagesModal.utils';

type Props = {
  positions: RestangularPosition[];
  updateWages: UpdateWages;
  afterSubmitCallback: () => void;
};
const useEmployeesWages = ({ positions, updateWages, afterSubmitCallback }: Props) => {
  const mappedPositions = mapPositionsFromRestangularToPositionOnboardingModel(positions);
  const { fields, submit, errors } = useDefineWagesForPositionsForm(mappedPositions, updateWages);

  const submitWages = useSubmitWages(submit, afterSubmitCallback);

  return { fields, submitWages, errors };
};

export default useEmployeesWages;
